import { Box, CircularProgress } from '@mui/material';
import { DisclosureResponsesSection } from 'src/components/pages/CoiDisclosures/DisclosureResponsesSection';
import {
  CaseType,
  DisclosureResponseType,
  useDisclosureCaseByIdQuery,
} from 'src/graphql';
import { CaseTypeEnum } from 'src/types';

export const DisclosureCaseResponses = ({
  caseById,
  responseInfo,
  caseType,
}: {
  caseById?: CaseType;
  responseInfo?: DisclosureResponseType | undefined;
  caseType: CaseTypeEnum;
}) => {
  const caseId = caseById?.id ?? '';
  const { data, isLoading, isError } = useDisclosureCaseByIdQuery(
    { caseId: caseId },
    { enabled: Boolean(caseId) },
  );

  const disclosureCaseById = data?.disclosureCaseById ?? responseInfo;
  const firstReport = caseById?.Reports?.[0];

  return (
    <>
      {isLoading ? (
        <Box
          data-testid="disclosures-table-loading"
          sx={{ display: 'flex', justifyContent: 'center', p: 6 }}
        >
          <CircularProgress />
        </Box>
      ) : (
        <DisclosureResponsesSection
          disclosureData={disclosureCaseById}
          isError={isError}
          reportId={firstReport?.id != null ? String(firstReport.id) : ''}
          caseType={caseType}
        />
      )}
    </>
  );
};
